// ni18n.config.ts
import type { Ni18nOptions } from 'ni18n'

export const ni18nConfig: Ni18nOptions = {
  supportedLngs: ['en', 'nl', 'fr'],
  ns: ['common', 'dashboard', 'events', 'login', 'orders', 'scans', 'settings', 'shows', 'tickets'],
}